@if (isLoadingResults) {
  <div class="example-loading-shade">
    <mat-spinner [style.zoom]="1"></mat-spinner>
  </div>
}
<div
  cdkDrag
  class="add_edit_common_main popup_main_div add_edit_searchandreplaceworkitem_main"
  cdkDragRootElement=".cdk-overlay-pane"
>
  <h2 cdkDragHandle mat-dialog-title class="mat-dialog-header">
    <span>Find/Replace</span>
    <button class="close-btn" mat-icon-button [mat-dialog-close]="false" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <div mat-dialog-content class="mat-typography main">
    <div class="one" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
      <form fxLayout="column" fxFlex="1 0 auto" name="form">
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <h3 fxFlex="100" class="pr-1 text-[14px]">
            This feature allows you to search for a specific word or phrase within unbilled time
            entries and replace all instances of it with another word or phrase, essentially making
            bulk edits to your text quickly and efficiently.
          </h3>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <h3 fxFlex="100" class="pr-1 text-[14px]">
            <strong>
              This process will prompt you for each unbilled Time Entry to make sure you want to
              change it.
            </strong>
          </h3>
        </div>

        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
          <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
            <mat-label>Find What</mat-label>
            <input
              matInput
              [disabled]="readonly"
              name="searchTerm"
              [(ngModel)]="searchTerm"
              [ngModelOptions]="{ standalone: true }"
              required
            />
          </mat-form-field>

          <mat-form-field appearance="outline" fxFlex="50" class="pr-1">
            <mat-label>Replace With</mat-label>
            <input
              matInput
              class="replace-term"
              [disabled]="readonly"
              name="replaceTerm"
              [(ngModel)]="replaceTerm"
              [ngModelOptions]="{ standalone: true }"
            />
          </mat-form-field>
        </div>

        <div fxLayout="column" fxLayoutAlign="start start" fxFlex="1 0 auto">
          <mat-checkbox
            class="checkwrap"
            aria-label="Match case"
            [(ngModel)]="matchCase"
            (ngModelChange)="checkUpdatedList()"
          >
            Match case
          </mat-checkbox>
          <mat-checkbox
            class="checkwrap"
            aria-label="Match whole word"
            [(ngModel)]="wholeWord"
            (ngModelChange)="checkUpdatedList()"
          >
            Match whole word
          </mat-checkbox>
        </div>
      </form>
    </div>
  </div>
  @if (showStartCancel) {
    <mat-dialog-actions class="popup_ftr justify-end!">
      <button
        matButton="filled"
        class="mat-accent"
        cdkFocusInitial
        (click)="CheckTermToUnbilledTimeEntries()"
      >
        @if (isspiner) {
          <mat-spinner diameter="24"></mat-spinner>
        }
        Start
      </button>
      <button matButton="tonal" cdkFocusInitial [mat-dialog-close]="false">Cancel</button>
    </mat-dialog-actions>
  }
  @if (!showStartCancel) {
    <mat-dialog-actions class="popup_ftr justify-end!">
      <!-- Use Angular Flex Layout for flexible grid -->
      <div fxLayout="row wrap" fxLayoutAlign="space-between start" fxFlex="100%">
        <!-- *ngIf='this.router.url =="/invoice/bulk-invoices"' -->
        <div fxFlex="50" class="pr-1">
          <!-- <mat-form-field appearance="outline" fxFlex="100%">
            <mat-label>Before Change</mat-label>
            <textarea class="textaheight" matInput [disabled]="readonly" name="CurrentAdditionalText" [(ngModel)]="CurrentAdditionalText" [ngModelOptions]="{standalone: true}" required></textarea>
          </mat-form-field> -->
          <mat-form-field appearance="outline" class="full-width pr-1" fxFlex="100">
            <mat-label>Before Change</mat-label>

            <textarea
              matInput
              name="CurrentAdditionalText"
              [(ngModel)]="CurrentAdditionalText"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="readonly"
              required
              rows="4"
              (keydown.enter)="$event.stopImmediatePropagation()"
            ></textarea>
          </mat-form-field>
        </div>
        <!-- *ngIf='this.router.url =="/invoice/bulk-invoices"' -->
        <div fxFlex="50" class="pr-1">
          <!-- <mat-form-field appearance="outline" fxFlex="100%">
          <mat-label>After Change</mat-label>
          <textarea  [ngStyle]="{ 'height.px': 45 }" matInput name="UpdatedAdditionalext" [(ngModel)]="UpdatedAdditionalext" [ngModelOptions]="{standalone: true}"></textarea>
        </mat-form-field> -->
          <mat-form-field appearance="outline" class="matter-textarea-wrapper pr-1" fxFlex="100">
            <mat-label>After Change</mat-label>

            <textarea
              matInput
              name="UpdatedAdditionalext"
              [(ngModel)]="UpdatedAdditionalext"
              [ngModelOptions]="{ standalone: true }"
              [style.height.px]="45"
              rows="2"
              (keydown.enter)="$event.stopImmediatePropagation()"
            ></textarea>
          </mat-form-field>
        </div>
        <!-- Spacer to separate from buttons -->
        <div fxFlex="100%" class="mt-2" fxLayoutAlign="end">
          <!-- Buttons on a new line aligned to the right -->
          <button
            matButton="filled"
            class="mat-accent"
            [disabled]="isspiner"
            (click)="isSkip = false; replaceTermToUnbilledTimeEntries()"
          >
            @if (isspiner) {
              <mat-spinner diameter="24"></mat-spinner>
            }
            Replace
          </button>
          <!-- <button mat-raised-button color="accent" class="mat-accent" [disabled]="isspiner" (click)="isSkip = true; skipFindReplace()">
          <mat-spinner *ngIf="isspiner"></mat-spinner> Skip
        </button> -->
          <button
            matButton="tonal"
            class="ml-2"
            [disabled]="isspiner"
            (click)="isSkip = true; skipFindReplace()"
          >
            @if (isspiner) {
              <mat-spinner diameter="24"></mat-spinner>
            }
            Don't Replace
          </button>
        </div>
      </div>
    </mat-dialog-actions>
  }
</div>
